import React from 'react';
import { Alert, AlertTitle, Box, Button } from '@mui/material';
import { BaseComponentProps } from '../../types';

interface ErrorMessageProps extends BaseComponentProps {
  error: string | Error;
  title?: string;
  action?: {
    label: string;
    onClick: () => void;
  };
  severity?: 'error' | 'warning' | 'info';
  fullWidth?: boolean;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({
  error,
  title = 'Error',
  action,
  severity = 'error',
  fullWidth = false,
  className,
}) => {
  const errorMessage = typeof error === 'string' ? error : error.message;

  return (
    <Box sx={{ width: fullWidth ? '100%' : 'auto' }} className={className}>
      <Alert
        severity={severity}
        action={
          action && (
            <Button
              color="inherit"
              size="small"
              onClick={action.onClick}
              variant="outlined"
            >
              {action.label}
            </Button>
          )
        }
      >
        <AlertTitle>{title}</AlertTitle>
        {errorMessage}
      </Alert>
    </Box>
  );
};

export default ErrorMessage;